import { Column } from '../../column';
import { RealEconomyProduct } from '../real-economy-macro-category';
import walletErDetailMessages from '../../../messages/wallet/wallet-er-detail.messages';

export const productErDetailColumns: Column<RealEconomyProduct>[] = [
  {
    headerLabel: walletErDetailMessages.productDescriptionColumn,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletErDetailMessages.contractColumn,
    key: 'newContractCode',
    type: 'string',
  },
  {
    headerLabel: walletErDetailMessages.commitmentColumn,
    key: 'obligation',
    type: 'amount',
  },
  {
    headerLabel: walletErDetailMessages.versatoColumn,
    key: 'paidValidated',
    type: 'amount',
  },
  {
    headerLabel: walletErDetailMessages.counterValueColumn,
    key: 'counterValue',
    type: 'amount',
  },
];
